import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Send({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M17.3508 3.77658C18.9308 3.22596 20.4482 4.74332 19.8975 6.32334L14.9125 20.6282C14.3039 22.3746 11.8545 22.4303 11.1671 20.7133L8.71495 14.588C8.61581 14.3404 8.67383 14.0575 8.86246 13.8688L13.1051 9.62621L14.0479 10.569L10.1162 14.5007L12.4049 20.2178C12.6341 20.7901 13.4505 20.7715 13.6534 20.1894L18.6385 5.88457C18.822 5.35789 18.3162 4.85211 17.7895 5.03565L3.48471 10.0207C2.90257 10.2236 2.88401 11.0401 3.45632 11.2692L7.29602 12.8063L6.80047 14.0442L2.96078 12.507C1.24385 11.8197 1.29954 9.37025 3.04593 8.76165L17.3508 3.77658Z"
        fill={iconColor}
      />
    </Svg>
  );
}
